import { forwardRef, Ref, SVGAttributes } from 'react'

type Props = SVGAttributes<SVGSVGElement>

const Right = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => (
  <svg
    ref={ref}
    width="14"
    height="10"
    viewBox="0 0 14 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.1426 0.285323C12.9597 0.102629 12.7118 0 12.4534 0C12.1948 0 11.9469 0.102632 11.764 0.285323L4.52298 7.52806C4.49248 7.55891 4.45086 7.57626 4.40754 7.57626C4.36421 7.57626 4.3226 7.55891 4.29209 7.52806L1.65999 4.89437C1.41311 4.65112 1.05568 4.55723 0.721002 4.6476C0.386357 4.7381 0.124843 4.99926 0.03412 5.3337C-0.0567162 5.66823 0.036728 6.02581 0.279751 6.27301L3.71648 9.71468C3.8994 9.89737 4.14731 10 4.40586 10C4.66431 10 4.9122 9.89737 5.09512 9.71468L13.1426 1.66719C13.3263 1.48415 13.4295 1.23558 13.4295 0.976211C13.4295 0.71697 13.3263 0.468395 13.1426 0.285352L13.1426 0.285323Z"
      fill="#0F8040"
    />
  </svg>
))

export default Right
